export const list = [
    { name: "Home", path: "/" },
    //{ name: "Technologie", path: "/technologie" },
    { name: "Oferta", path: '/oferta' },
    { name: "Realizacje", path: "/realizacje" },
    { name: "Kontakt", path: "/kontakt" },
]